import { FC } from 'react';
import { IconNames } from 'components/Icon';
import { ENV_CONFIG } from 'config/environment';
import { DashboardScreen, trackEvent } from 'helpers/mixpanelEvents';
import { BadgeCtaCard } from './BadgeCtaCard';
import { IMPACT_SCORE_RESOURCE_CENTER_ARTICLE_PATH } from './constants';

const SCREEN: DashboardScreen = 'recipients_dashboard';

export const ResourceLibraryCta: FC = () => (
  <BadgeCtaCard
    icon={IconNames.Folder}
    title="Resource library"
    description="Press release template + guide for collaborating with Oath on Instagram."
    action={
      <button
        type="button"
        className="btn-inkBlue btn btn-secondary"
        onClick={() => {
          trackEvent('Resource Library Clicked', { screen: SCREEN });
          const win = window.open(
            `${ENV_CONFIG().RECIPIENT_HELP_CENTER_URL}${IMPACT_SCORE_RESOURCE_CENTER_ARTICLE_PATH}`,
            '_blank',
            'noopener,noreferrer'
          );
          if (win) win.opener = null;
        }}
      >
        <span className="body-small-text text-white">View Resources</span>
      </button>
    }
  />
);
